import { render, staticRenderFns } from "./drug_age-range.vue?vue&type=template&id=77ff9685&"
import script from "./drug_age-range.vue?vue&type=script&lang=js&"
export * from "./drug_age-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports